import {
  TransactionGroup,
  Transactions,
} from 'shared/components/TransactionSectionList/TransactionSectionList';
import { TransactionListItemProps } from 'shared/components/vxl/TransactionListItem/TransactionListItem';
import { SectionedContentScreenSection } from 'shared/containers/vxl/SectionedContentScreen/SectionedContentScreen';
import { VXLComponentId } from 'shared/renderer/types';

export type TransactionListItemPropsWithDetail = TransactionListItemProps & {
  secondaryDetail?: string;
};

const isTransactionGroupArray = (
  transactions: Transactions | undefined,
): boolean => {
  return (
    (transactions && transactions.length > 0 && 'title' in transactions[0]) ??
    false
  );
};

const adaptTransactionGroupToSectionedContentModel = (
  transaction: TransactionGroup,
): SectionedContentScreenSection => {
  return {
    sectionHeader: {
      id: `Header-${transaction.title}`,
      name: VXLComponentId.SECTION_DIVIDER,
      props: {
        labelText: transaction.title,
      },
    },
    data: transaction.transactions.map(
      (transaction: TransactionListItemPropsWithDetail) => {
        const buildId = `${transaction.titleText}-${transaction.secondaryText}-${transaction.amountText}-${transaction.analyticsId}-${transaction.secondaryDetail}`;
        return {
          id: buildId,
          name: VXLComponentId.TRANSACTION_LIST_ITEM,
          props: transaction,
        };
      },
    ),
  };
};

const adaptTransactionListItemPropsSectionedContentModel = (
  transactions: TransactionListItemPropsWithDetail[],
): SectionedContentScreenSection => {
  return {
    data: transactions.map((transaction) => {
      const buildId = `${transaction.titleText}-${transaction.secondaryText}-${transaction.amountText}-${transaction.analyticsId}-${transaction.secondaryDetail}`;
      return {
        id: buildId,
        name: VXLComponentId.TRANSACTION_LIST_ITEM,
        props: transaction,
      };
    }),
  };
};

const adaptTransactionsToSections = (
  transactions: Transactions,
): SectionedContentScreenSection[] | [] => {
  if (isTransactionGroupArray(transactions)) {
    return (transactions as TransactionGroup[]).map((transaction) => {
      return adaptTransactionGroupToSectionedContentModel(
        transaction as TransactionGroup,
      );
    });
  }
  return [
    adaptTransactionListItemPropsSectionedContentModel(
      transactions as TransactionListItemPropsWithDetail[],
    ),
  ];
};

export default adaptTransactionsToSections;
